import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import DealerByPostcodeModule from '../components/DealerByPostcodeModule';
import MaintenanceMessage from '../components/MaintenanceMessage';
import { formatMobile } from '../functions/textFormatting';
import { gtmPageview } from '../functions/gtm';
import queryString from 'query-string';
import {
    UI_AUDI_MIN,
    PATH_REQUEST_QUOTE,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_CHECKBOX,
    FIELD_CHECKBOX_GROUP,
    FIELD_RADIO,
    LABEL_OPTIN,
    PLANNING_TO_BUY_OPTIONS,
    PREF_CONTACT_OPTIONS,
    MAINTENANCE_SF
} from '../constants';

const mapStateToProps = state => {
    return {
        referrer: state.ui.referrer
    };
}

class RequestQuote extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_REQUEST_QUOTE);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        // this.props.history.push(`${PATH_REQUEST_QUOTE}${PATH_THANKS}`);
        gtmPageview(`${PATH_REQUEST_QUOTE}${PATH_THANKS}`);
        window.scrollTo(0,0);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {referrer, match} = this.props;
        const {submitted, submittedData} = this.state;
        var code = match.params.audicode || "";
        var refModel = "";
        if (referrer && referrer.indexOf("audi.com.au") !== -1 && referrer.indexOf("/models/") !== -1) {
            let midx = referrer.indexOf("/models/");
            let a = referrer.substring(midx + 1).split("/");
            refModel = a[2].toLowerCase();
        }
        if (!refModel && query && query.carline) {
            // get carline from query string
            refModel = query.carline.toLowerCase();
        }
        var fields = [
            [
              {
                  field: FIELD_TEXT,
                  name: "firstName",
                  label: "First name *",
                  colClass: "col-12 col-tiny"
              },
              {
                  field: FIELD_TEXT,
                  name: "lastName",
                  label: "Last name *",
                  colClass: "col-12 col-tiny"
              },
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email address *"
            },
            {
                field: FIELD_TEXT,
                name: "mobilePhone",
                label: "Mobile phone *",
                formatValue: formatMobile
            },
            {
                field: FIELD_CHECKBOX_GROUP,
                name: "preferredContactMethod",
                label: "Preferred method of contact *",
                options: PREF_CONTACT_OPTIONS,
                delimeter: ";",
                value: "Email",
                className: "mt-4 pt-2",
                checkboxClassName: "me-5 mb-3"
            },
            {
                module: DealerByPostcodeModule,
                postcodeName: "postCode",
                formName: "requestQuote"
            },
            {
                field: FIELD_CHECKBOX,
                name: "optIn",
                label: LABEL_OPTIN,
                className: "mt-4"
            },
            {
                field: FIELD_CHECKBOX,
                name: "tradeIn",
                label: "I'd like to discuss trade in options."
            }
        ];
        var nVer = "", nAgt = "", nName = "";
        if (typeof navigator !== 'undefined') {
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var nName  = navigator.appName;
        }
        return (
            <Layout ui={query.ui || UI_AUDI_MIN} embedded={query.embedded} theme={query.theme}>
                <Helmet>
                    <title>Request a Quote | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && <div className="pb-5 pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you</h1>
                        <p className="mb-3">Your request has been submitted and a confirmation email will be sent to you shortly.</p>
                        {submittedData?.dealerName && <p className="mb-3">A team member from <b>{submittedData.dealerName}</b> will be in touch regarding your quote.</p>}
                        <p className="pb-5 mt-5"><ReturnToButton query={query} theme={query.theme} /></p>
                    </div>}

                    {!submitted && <div className="pb-5 pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Request a quote</h1>
                        {MAINTENANCE_SF && <MaintenanceMessage />}
                        <p className="mb-3">
                            Enter your details and we'll provide a quote on the
                            {` `}<a className="aui-textlink" target="_blank" rel="noopener noreferrer" href={`https://www.audi.com.au/${code}`}>Audi you built</a>.
                        </p>
                        {!refModel && <p className="aui-color-text-red mb-3">To submit another ‘Request a quote’ enquiry, please go back to the Audi configurator summary page and use the ‘Request a Quote’ button.</p>}

                        <AudiForm formName="requestQuote"
                            fields={fields}
                            hiddenFields={{audicode: code, dealerContact: true, RequestQuoteModel: refModel, referrer, browser: {nVer, nAgt, nName}}}
                            preSubmit={(payload) => {
                                if (payload.dealer) {
                                    payload.dealer = "";
                                }
                                return payload;
                            }}
                            onSubmitSuccess={this.onSubmit}
                            submitLabel="Request a quote"
                            style={{maxWidth: "800px"}}
                            disabled={!refModel || refModel === ""}
                            theme={query.theme}
                        />
                        <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
                        <Disclaimer />
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default connect(mapStateToProps)(RequestQuote);
